import { render, staticRenderFns } from "./SettingsBotTheme.vue?vue&type=template&id=5f2bd0cc&scoped=true&"
import script from "./SettingsBotTheme.vue?vue&type=script&lang=js&"
export * from "./SettingsBotTheme.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotTheme.vue?vue&type=style&index=0&id=5f2bd0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bd0cc",
  null
  
)

export default component.exports